import React, { useState, useEffect, useRef } from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
    Spinner,
} from "reactstrap";
import { getAuthorAll } from "../../api/admin";

const AuthorDropdown = ({ value, onChange, onBlur }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [authors, setAuthors] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const menuRef = useRef(null);

    const toggle = () => setDropdownOpen((prev) => !prev);

    const fetchAuthors = async (reset = false) => {
        if (loading || (!hasMore && !reset)) return;
        setLoading(true);

        try {
            const { status, data, hasMore: more } = await getAuthorAll({
                search,
                page,
                limit: 10,
            });

            if (status) {
                setAuthors((prev) => (reset ? data : [...prev, ...data]));
                setHasMore(more);
            }
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    };

    // reset when search changes
    useEffect(() => {
        setPage(1);
        setAuthors([]);
        setHasMore(true);
    }, [search]);

    // fetch on search or page change
    useEffect(() => {
        fetchAuthors(page === 1);
    }, [page, search]);

    const handleScroll = () => {
        if (!menuRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = menuRef.current;
        if (
            scrollTop + clientHeight >= scrollHeight - 5 &&
            hasMore &&
            !loading
        ) {
            setPage((prev) => prev + 1);
        }
    };

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className="w-100">
            <DropdownToggle
                caret
                block
                className="w-100 text-start"
                onBlur={onBlur}
            >
                {value ? authors.find((a) => a._id === value)?.name || "Select Author" : "Select Author"}
            </DropdownToggle>
            <DropdownMenu
                style={{ maxHeight: "250px", overflowY: "auto" }}
                className="w-100"
                ref={menuRef}
                onScroll={handleScroll}
            >
                <div className="p-2">
                    <Input
                        type="text"
                        placeholder="Search author..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                {authors.map((author) => (
                    <DropdownItem key={author._id} onClick={() => onChange(author._id)}>
                        {author.name}
                    </DropdownItem>
                ))}
                {loading && (
                    <div className="text-center p-2">
                        <Spinner size="sm" />
                    </div>
                )}
                {!hasMore && authors.length > 0 && (
                    <div className="text-center text-muted p-2">No more authors</div>
                )}
            </DropdownMenu>
        </Dropdown>
    );
};

export default AuthorDropdown;